module.exports = __webpack_public_path__ + "img/Footer-Paypal.6938802.svg";